import { RefObject, useEffect } from 'react';

export function useAutoFocus(
  ref: RefObject<HTMLElement | null>,
  enabled = true,
) {
  useEffect(() => {
    if (!enabled) return;
    let innerFrame: number | null = null;
    const outerFrame = requestAnimationFrame(() => {
      innerFrame = requestAnimationFrame(() => {
        ref.current?.focus();
      });
    });
    return () => {
      cancelAnimationFrame(outerFrame);
      if (innerFrame !== null) {
        cancelAnimationFrame(innerFrame);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
